import { UserProfile } from "@blacknut/javascript-sdk/dist";
import { getFamilyInfo as apiGetFamilyInfo } from "@blacknut/javascript-sdk/dist/api/Family/getFamilyInfo";
import { Dispatch } from "redux";
import { ProfilesAction, ProfilesActionTypes } from "./Profiles";

import { forkJoin } from "rxjs";

export const loadFamilyInfoSuccess = (profiles?: UserProfile[]): ProfilesAction => {
  return {
    type: ProfilesActionTypes.LOAD_FAMILY_INFO_SUCCESS,
    profiles,
  };
};

export const dismissFamilyInfoLoadError = () => {
  return (dispatch: Dispatch<ProfilesAction>) => {
    dispatch({ type: ProfilesActionTypes.LOAD_FAMILY_INFO_ERROR, error: undefined });
  };
};
export const loadFamilyInfo = () => {
  return (dispatch: Dispatch<ProfilesAction>) => {
    return new Promise<{ profiles: UserProfile[] }>((resolve, reject) => {
      dispatch({ type: ProfilesActionTypes.LOAD_FAMILY_INFO_REQUEST });

      forkJoin({
        info: apiGetFamilyInfo(),
      }).subscribe({
        next: (value) => {
          dispatch(loadFamilyInfoSuccess(value.info.profiles));
          resolve({ profiles: value.info.profiles });
        },
        error: (error) => {
          dispatch({ type: ProfilesActionTypes.LOAD_FAMILY_INFO_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
